import { Container, Typography } from "@mui/material";
import HowToStartTabs from "./HowToStartTabs/HowToStartTabs";
import styles from "./HowToStart.module.css";

const HowToStart = (props) => {

  const {redirectToForm,getStartedHandler} = props;

  return (
    <Container className={styles.parentContainer} sx={{ mt: 15 }} >
        <Typography
          variant="h3"
          sx={{
            color: "#FFFFFF",
            fontWeight: "600",
            textAlign: "center",
            letterSpacing: "1px",
          }}
        >
          How to start
        </Typography>
        <HowToStartTabs redirectToForm={redirectToForm} getStartedHandler={getStartedHandler}/>
    </Container>
  );
};

export default HowToStart;
